import { CircularProgress, Grid, Tab, Tabs } from '@material-ui/core';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const RenderTab = props => {
  const { classes, handleViewChange, mainColor, view, loadingDocuments, isInternalForm } = props;
  return (
    <Grid container spacing={3} className={classes.tabsContainer}>
      <Tabs
        variant="scrollable"
        onChange={handleViewChange}
        className={classes.tabs}
        indicatorColor={mainColor ? mainColor : 'primary'}
        textColor={mainColor ? mainColor : 'primary'}
        value={view}
      >
        <Tab className={classes.tab} label={<FormattedMessage id="LABELS.VEHICLES.VEHICLES" />} />
        {loadingDocuments && !isInternalForm && (
          <Tab
            className={classes.tab}
            label={<CircularProgress size={12} className={classes.loading} />}
          />
        )}
        {!isInternalForm && !loadingDocuments && (
          <Tab
            className={classes.tab}
            label={<FormattedMessage id="LABELS.COMMONS.DOCUMENTATION" />}
          />
        )}
      </Tabs>
    </Grid>
  );
};

export default injectIntl(RenderTab);
